import { sessionStorageUtils } from '@/lib/storageUtils';

const STORAGE_KEY = 'volt_flow_override';
const QUERY_PARAM = 'flow';

// Where the user continues after signing in, overriding the app-redirect
// experiment: `web` keeps them on the web (credit marketing campaigns that
// must not be pushed to the app), `app` forces the app-redirect screen.
export type FlowOverride = 'web' | 'app';

const FLOW_OVERRIDES: readonly string[] = ['web', 'app'];

const isFlowOverride = (value: string | null): value is FlowOverride =>
  value !== null && FLOW_OVERRIDES.includes(value);

export const flowOverrideService = {
  // Reads `?flow=` from the landing URL before routing strips the params and
  // keeps it for the tab session, so the override survives the OTP round trip
  // and reloads without leaking into the user's next visit.
  capture(): void {
    const flow = new URLSearchParams(window.location.search).get(QUERY_PARAM);
    if (!isFlowOverride(flow)) {
      return;
    }

    sessionStorageUtils.set<FlowOverride>(STORAGE_KEY, flow);
  },

  // A value kept from the former flow experiment (`v1`, `v4`…) counts as none.
  get(): FlowOverride | null {
    const flow = sessionStorageUtils.get<string>(STORAGE_KEY);
    return isFlowOverride(flow) ? flow : null;
  },

  clear(): void {
    sessionStorageUtils.remove(STORAGE_KEY);
  },
};
